import { fetcher } from '../utils'
import { ComponentMessageVO } from '@repo/types'

export default async (input: FormData, connectionKey: string, phoneNumber: string): Promise<ComponentMessageVO> =>
  fetcher(`/api/chats/${connectionKey}/${phoneNumber}/upload`, 'POST', undefined, input)
